import React, {Fragment, useEffect, useState} from "react";
import {NavLink, useLocation, useParams} from "react-router-dom";

import axios from "axios";
import clientconfigwebapp, {
    check_login_appbk, empty_bk, Token_get_appbk, NewlineText_bk, Get_Weight_txt_bk
} from "../../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";
import Grid from '@mui/material/Grid';
import Slider_Galley_Image from "../../../components/Sliders_box/Slider_Galley_Image";
import {
    Icon_User,
    Icon_Location,
    Icon_inventory,
    Icon_Insurance,
    Icon_Packaging_and_label,
    Icon_Quality_Control,
    Icon_Transportation,
    Icon_Customs_formalities,
    Icon_singpro_Authenticated,
    Icon_btn_tiket_singprod,
    Icon_btn_call_singprod,
} from "../../../assets/icones/icones_single_products";
import Sticky from "react-stickynode";
import Modal from "@mui/material/Modal";
import Grow from "@mui/material/Grow";
import Box from "@mui/material/Box";
import Call_Modal_Message from "../../../components/Call_Modal_Message/Call_Modal_Message";


const Section_1 = (props) => {

    ///const [open, setOpen_modal_call] = React.useState(false);
    const [open, setOpen_modal_call] = useState(false);
    const [modal_info_get, Set_modal_info_get] = useState([]);
    const handle_modal_call_Open = (data_info_get) => {
        Set_modal_info_get(data_info_get);
        setOpen_modal_call(true);

    };

    const style_modal_call = {
        position: 'absolute',
        top: '20%',
        left: '35%',
        transform: 'translate(-35%, -35%)',
        width: "35%",
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: "10px",
    };
    const handle_modal_call_Close = () => {

        setOpen_modal_call(false);
    };


    function NewlineTextbk(props) {
        var text = props.text;

        // جایگزینی انواع شکست‌های خط و حذف بک‌اسلش‌های اضافه
        text = text.replace(/\r\n/g, '\n'); // جایگزینی همه \r\n با \n
        text = text
            .replace(/\\n|\r\n|\r|\n/g, '\n') // جایگزینی انواع دیگر شکست‌های خط
            .replace(/\\/g, '') // حذف هرگونه بک‌اسلش اضافه
            .replaceAll("r", " "); // جایگزینی حرف r با فضای خالی

        // تقسیم رشته به خطوط مجزا و نمایش هر خط به‌صورت یک پاراگراف
        const text_ebnd = text.split('\n').map((str, index) => <p key={index}>{str}</p>);

        return text_ebnd;
    }

    return (<Fragment>

            <Grid id={"bbb2"} container direction="row" spacing={2} style={{paddingTop: "14px"}}>


                <Grid id={"content"} item lg={8.5} md={8.5} sm={12} xs={12}>

                    <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>


                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <Slider_Galley_Image image_alt={""} data_slider_list={props.data_slider_list}/>
                        </Grid>


                        <Grid className={"box-info-single-product-box"} item lg={6} md={6} sm={12} xs={12}>
                            <div className={"box-info-single-product"}>
                                <div style={{width: "100%"}}>
                                    <h1 className={"title-single-prodh1"}>{props.data_paged_info.title_post}</h1>
                                    <ul className={"list-icons-detailsprod"}>
                                        <li>
                                            <Icon_User/><span
                                            className={"list-texta-details-prod"}>نام فروشنده:</span><span
                                            className={"list-textb-details-prod"}>{String(props.data_paged_info.seller_first_name) + " " + String(props.data_paged_info.seller_last_name)}</span>
                                        </li>
                                        <li>
                                            <Icon_Location/><span
                                            className={"list-texta-details-prod"}>لوکیشن:</span><span
                                            className={"list-textb-details-prod"}>{String(props.data_paged_info.state_text) + " " + String(props.data_paged_info.city_text)}</span>
                                        </li>
                                        <li>
                                            <Icon_inventory/><span
                                            className={"list-texta-details-prod"}>میزان موجودی:</span><span
                                            className={"list-textb-details-prod"}>{Get_Weight_txt_bk(String(props.data_paged_info.order_amount))}</span>
                                        </li>
                                        <li>
                                            <Icon_inventory/><span
                                            className={"list-texta-details-prod"}>حداقل میزان فروش:</span><span
                                            className={"list-textb-details-prod"}>{Get_Weight_txt_bk(String(props.data_paged_info.order_amount))}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className={"box-list-icon-info-b"}>
                                    <ul className={"list-icons-info-b"}>
                                        <li>
                                            <Icon_Insurance/><span className={"list-texta-details-prod"}>بیمه</span>
                                        </li>
                                        <li>
                                            <Icon_Packaging_and_label/><span className={"list-texta-details-prod"}>بسته بندی و لیبل</span>
                                        </li>
                                        <li>
                                            <Icon_Quality_Control/><span
                                            className={"list-texta-details-prod"}>کنترل کیفیت</span>
                                        </li>
                                        <li>
                                            <Icon_Transportation/><span
                                            className={"list-texta-details-prod"}>حمل و نقل</span>
                                        </li>
                                        {/*<li>*/}
                                        {/*    <Icon_Customs_formalities/><span className={"list-texta-details-prod"}>تشریفات گمرکی</span>*/}
                                        {/*</li>*/}
                                    </ul>
                                </div>
                            </div>

                        </Grid>


                    </Grid>


                    <div style={{"borderTop": "1px solid #D1D5DB", "paddingTop": "15px", "paddingBottom": "10px"}}>

                        <span className={"title_section_desc_single_prod"}>توضیحات محصول</span>
                        {/*<div className={"description_single_product"}*/}
                        {/*     dangerouslySetInnerHTML={{__html: NewlineText_bk(String(props.data_paged_info.description))}}></div>*/}

                        <div className={"description_single_product"} >
                            <NewlineTextbk text={String(props.data_paged_info.description)} />
                        </div>



                    </div>


                </Grid>


                <Grid className={"sidebarrightbk_singleproduct"} id="sidebarrightbk" item lg={3.5} md={3.5} sm={12}
                      xs={12}>
                    {/*<Sticky top="#headerbk" bottomBoundary="#content">*/}
                    <Sticky top="#headerbk" bottomBoundary="#contentbottomendsingle">
                        <div className={"box-card-sidebar-fixed"}>

                            <div className={"box-card-info-seller"}>
                                <img className={"single_prod_seller_image"}
                                     src={String(props.data_paged_info.seller_image_src)}
                                     alt={String(props.data_paged_info.seller_first_name) + " " + String(props.data_paged_info.seller_last_name)}/>

                                <div style={{
                                    "width": "100%",
                                    "display": "flex",
                                    "flexDirection": "column",
                                    "flexWrap": "wrap",
                                    "alignContent": "flex-start",
                                    "justifyContent": "space-between",
                                    "alignItems": "flex-start"
                                }}>
                                          <span
                                              className={"single_prod_name_seller"}>{String(props.data_paged_info.seller_first_name) + " " + String(props.data_paged_info.seller_last_name)}</span>




                                    <div className={"type_user_andAuthenticated"}><span
                                        className={"single_prod_type_user"}>فروشنده</span>



                                        { props.data_paged_info && props.data_paged_info.user_authentication && props.data_paged_info.user_authentication == "yes"  ? (
                                            <div className={"seller_info_box_Authenticated "}>
                                                <svg width={14} height={14} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M5.41667 9.70841L3.25 7.54175L4.01375 6.778L5.41667 8.1755L8.98625 4.60591L9.75 5.37508M6.5 1.04175L1.625 3.20841V6.45841C1.625 9.46466 3.705 12.2759 6.5 12.9584C9.295 12.2759 11.375 9.46466 11.375 6.45841V3.20841L6.5 1.04175Z"
                                                        fill="#01A3D4"/>
                                                </svg>
                                                <span>احراز هویت شده</span>
                                            </div>
                                        ):(
                                            <div className={""}></div>
                                        )
                                        }





                                    </div>



                                </div>
                            </div>


                            <div style={{"marginTop": "10px", "marginBottom": "10px"}}>
                                <span className={"title_business"}>توضیحات کسب و کار</span>

                                <div className={"seller_about_text"}>
                                    {props.data_paged_info.description_me}
                                </div>

                                <div className={"seller-btns-box-call"}>

                                    <NavLink className="btn-bk-new btn-bk-new-blue-out"  to={
                                        check_login_appbk()
                                            ? `/panel/tickets/${String(props.data_paged_info?.id_ticket || '')}`
                                            : `/login-register/?redirect=panel/tickets/${String(props.data_paged_info?.id_ticket || '')}`
                                    }>
                                        <Icon_btn_tiket_singprod/>
                                        <span style={{color: 'rgb(1, 163, 212)'}}>ارسال تیکت</span>
                                    </NavLink>
                                    <button  type={"button"} onClick={ () => { handle_modal_call_Open(props.data_paged_info)  } } className="btn-bk-new btn-bk-new-orange" >
                                        <Icon_btn_call_singprod/>
                                        <span style={{color: 'rgb(1, 163, 212)'}}>تماس با خریدار</span>
                                    </button>


                                </div>

                            </div>


                        </div>
                    </Sticky>



                </Grid>


            </Grid>


        <div id={"contentbottomendsingle"}></div>

        <Modal
            id={"modal_call"}
            open={open}
            onClose={handle_modal_call_Close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disableScrollLock={false}
            keepMounted={true}
            hideBackdrop={false}
            disablePortal={true}  ////render current dom
            className={"modal_muibk"}
        >

            <Grow style={{transformOrigin: '0 0 0'}} {...(open ? {timeout: 1000} : {})} in={open}>
                <Box className={"box-modal-bkb"} sx={style_modal_call}>


                    <div className={"header-modal-bkb"}>
                        <span style={{"fontWeight":"bold","fontSize":"15px","fontFamily":"'iran'"}}>اطلاعات تماس</span>
                        <span className={"btn-close-modal-bkb"} onClick={handle_modal_call_Close} style={{
                            "color": "#9b9b9b",
                            "position": "relative",
                            "left": "0px",
                            "top": "0px",
                            "fontSize": "23px",
                            "cursor": "pointer"
                        }}>X</span>

                    </div>


                    <div className={"modal2-content-box"}><Call_Modal_Message modal_info_get={modal_info_get}/></div>


                </Box>

            </Grow>
        </Modal>

        </Fragment>);
}

export default Section_1;
